import { ISelectedFtthProduct, ISelectedProductStb, ISelectedProductAdditionalItem, ISelectedProductWithPurchaseType } from "./types";

export default class SelectedFtthProduct implements ISelectedFtthProduct {

  id: number;
  productLine: string;
  stb: ISelectedProductStb;
  fix: ISelectedProductWithPurchaseType;
  additionalItems:  ISelectedProductAdditionalItem[] | [];
  feasibilityData: any | null;
  customerData: any | null;
  existingCustomer: boolean;

  constructor(
    id: number,
    productLine: string,
    stb: ISelectedProductStb,
    fix: ISelectedProductWithPurchaseType,
    additionalItems: ISelectedProductAdditionalItem[] | [],
    feasibilityData: any | null,
    customerData: any | null,
    existingCustomer: boolean,
  ) {
    this.id = id;
    this.productLine = productLine;
    this.stb = stb;
    this.fix = fix;
    this.additionalItems = additionalItems;
    this.feasibilityData = feasibilityData;
    this.customerData = customerData;
    this.existingCustomer = existingCustomer;
  }

}
